import React, { useState } from "react";
import { Button, Modal } from "antd";
import Select from "react-select";

const ViewTestimonials = ({ singleData, openModal, onClose }) => {
  const [inputData] = useState({
    name: singleData?.name,
    rating: { label: singleData?.rating, value: singleData?.rating },
    designation: singleData?.designation,
    companyName: singleData?.companyName,
    review: singleData?.review,
  });

  return (
    <Modal
      title={
        <div
          style={{
            background: "#006666",
            color: "#fff",
            padding: "12px",
            borderRadius: "4px",
          }}
        >
          View Testimonials
        </div>
      }
      centered
      open={openModal}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={[
        <Button
          key="ok"
          type="primary"
          style={{ background: "#006666", color: "white" }}
          onClick={(e) => {
            onClose();
          }}
        >
          OK
        </Button>,
      ]}
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input
                    class={`form-control`}
                    type="text"
                    placeholder="Enter Name.."
                    value={inputData?.name}
                    disabled
                  />
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Company Name</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Company Name.."
                    value={inputData?.companyName}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Designation</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Designation.."
                    value={inputData?.designation}
                    disabled
                  />
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Rating</label>
                  <Select
                    className={``}
                    value={inputData?.rating}
                    isDisabled
                    options={[
                      { label: "1", value: 1 },
                      { label: "2", value: 2 },
                      { label: "3", value: 3 },
                      { label: "4", value: 4 },
                      { label: "5", value: 5 },
                    ]}
                  ></Select>
                </div>
              </div>

              <div class="col-sm-12 col-md-12">
                <div class="mb-3">
                  <label class="form-label">Review</label>
                  <textarea
                    class={`form-control `}
                    type="textarea"
                    placeholder="Enter Review.."
                    value={inputData?.review}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewTestimonials;
